var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69143 9.87573C9.69143 9.87573 8.16797 10.7597 8.16797 12.7327C8.16797 12.9711 6.93035 16.113 6.93035 16.113C6.93035 16.113 4.26426 18.2082 3.64502 20.255H7.26372C7.26372 20.255 7.50208 19.6358 6.2161 19.2549L8.59631 16.5889L11.2149 13.0177L14.0243 16.1121C14.0243 16.1121 14.5961 18.9691 16.2146 20.2542H18.9281C18.9281 20.2542 18.1664 19.2541 17.1663 19.2541L15.5953 15.5404L14.0718 11.9692L9.69143 9.87573Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0067 9.69638C11.8064 9.04196 13.606 8.38754 15.4057 7.73311L16.0267 1.57237C16.054 1.29969 16.2537 1.07539 16.5211 1.01558C16.9354 0.923223 17.3215 1.25395 17.2933 1.67704C17.186 3.30343 17.0426 6.81568 17.6918 8.11398C17.6918 8.11398 16.5017 9.54246 17.6918 10.9709C17.6918 10.9709 18.501 11.971 18.406 13.542L20.0307 19.416C20.1477 19.8382 19.8301 20.256 19.3912 20.256C19.1132 20.256 18.8652 20.0827 18.7693 19.8233L16.025 12.4003L14.0731 11.9719L9.99177 9.99721C9.86159 9.93388 9.87126 9.74564 10.0067 9.69638Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8334 9.54266C21.8334 10.6211 20.959 11.4945 19.8815 11.4945C18.804 11.4945 17.9297 10.6202 17.9297 9.54266C17.9297 8.46427 18.804 7.59082 19.8815 7.59082C20.959 7.59082 21.8334 8.46515 21.8334 9.54266Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.2561H22.9021",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.77b8514423c3d8c7db41a1a5c043d6b3.svg";
export { ForwardRef as ReactComponent };